/* ------------------------------------------------------------------------------
@name: Header
@description: Header
--------------------------------------------------------------------------------- */

const Header = (() => {
  // - handleSetHeader
  const handleSetHeader = () => {};

  const init = () => {
    handleSetHeader();
  };

  return {
    init
  };
})();

export default Header;
